import { MODAL_ROUTE } from '@/constants';
import { useAppDispatch } from '@/features';
import { openModal } from '@/features/slice/event/event-slice';
import { useGetExpensesQuery } from '@/features/slice/expense/expense-api-slice';

import { useUrlPagination } from '../../../hooks';

export const useExpense = () => {
    const { page, limit } = useUrlPagination();

    const dispatch = useAppDispatch();

    const { data, isError, isLoading } = useGetExpensesQuery({
        page,
        limit,
    });

    const openCreateExpenseModal = () =>
        dispatch(openModal({ content: MODAL_ROUTE.CREATE_EXPENSE }));

    return {
        data,
        isError,
        isLoading,
        openCreateExpenseModal,
    };
};
